import React, { useState } from "react";
import { api } from "../../../services/api";

interface LogoRefineOverlayProps {
  selectedLogo: string;
  onRefined: (newLogo: string) => void;
  onClose: () => void;
}

const LogoRefineOverlay: React.FC<LogoRefineOverlayProps> = ({
  selectedLogo,
  onRefined,
  onClose,
}) => {
  const [feedback, setFeedback] = useState("");
  const [refining, setRefining] = useState(false);
  const [error, setError] = useState("");

  const imgSrc = (src: string) =>
    src.startsWith("data:") || src.startsWith("http") ? src : `data:image/png;base64,${src}`;

  const handleRefine = async () => {
    if (!feedback.trim() || !selectedLogo) return;
    setRefining(true);
    setError("");
    try {
      const data = await api.refineLogo(feedback.trim(), selectedLogo);
      const refined = data.refined_logo_base64;
      onRefined(refined.startsWith("data:") ? refined : `data:image/png;base64,${refined}`);
      setFeedback("");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Refinement failed. Please try again.");
    } finally {
      setRefining(false);
    }
  };

  return (
    <div className="bk-refine-modal-overlay" onClick={onClose}>
      <div className="bk-refine-modal" onClick={e => e.stopPropagation()}>
        <div className="bk-refine-modal-img">
          {selectedLogo && <img src={imgSrc(selectedLogo)} alt="Your logo" />}
        </div>

        <div className="bk-refine-modal-panel">
          <div className="bk-eyebrow">Refine your logo</div>

          {error && <div className="bk-error" style={{ marginBottom: "1rem" }}>{error}</div>}

          <textarea
            className="bk-textarea"
            style={{ minHeight: "100px", marginBottom: "0" }}
            placeholder="e.g. Make the shield larger, use gold instead of yellow, add more detail"
            value={feedback}
            onChange={e => setFeedback(e.target.value)}
            disabled={refining}
            rows={4}
          />

          <div className="bk-refine-actions">
            <button
              className={refining ? "bk-btn-ghost bk-btn-blank" : "bk-btn-ghost"}
              onClick={handleRefine}
              disabled={refining || !feedback.trim()}
            >
              Refine
            </button>
            <button className="bk-btn" onClick={onClose} disabled={refining}>
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoRefineOverlay;
